import {useState, useEffect} from 'react';
import {Row, Col} from 'react-bootstrap'
import styled from 'styled-components';

import jdata from "../Home/data.json";
import pkg from '../../../package.json';

const Copyright = styled.a`
  margin: 0;
  text-decoration: none;
`;

const Footer = ({lang='ar',etat}) => {
    const data = jdata.Contact
    const local = lang==='ar' ? "ar-MA" : "en-US"
    const options = {hour12:false, weekday:'short'} //long 
    const [time, Time] = useState("");

    useEffect(() => {
        setTimeout(() => {
            Time((new Date()).toLocaleTimeString(local,options))
        }, 1000);
    },[time]);

    return (
        <Row className="Footer">
            <Col sm={3}>
            <i className="FooterEtat" id="FooterEtat">{etat}</i>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={data.telegram}><img src="content/icons/s-telegram.png" alt="telegram" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.linkedin.com/company/rais-digital-services"}><img src="content/icons/linkedin.png" alt="linkedin" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://x.com/RaisDigital"}><img src="content/icons/x.png" alt="x rep twitter" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={data.facebook}><img src="content/icons/facebook.png" alt="facebook" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={data.instagram}><img src="content/icons/instagram.png" alt="instagram" title="instagram" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={data.youtube}><img src="content/icons/youtube.png" alt="youtube" title="youtube" /></a>
            </Col>
            <Col  sm={2}>
                <Copyright href="https://digitalservices.com" target="_blank" rel="noopener noreferrer" title={pkg.version} >
                    &copy; {jdata.Header.company}  {new Date().getFullYear()} 
                </Copyright>
            </Col>
            <Col sm={1} style={{right:0}}>
            {time}
            </Col>
        </Row>
    )
}

export default Footer;

